import React, { CSSProperties } from "react";
import classNames from "classnames";
import { Typography, TypographyProps } from "antd";
import { TitleProps } from "antd/lib/typography/Title";

import { BemHelper } from "../../utils";

type Props = TypographyProps["defaultProps"] &
  TitleProps & {
    style?: CSSProperties;
    variant?: 1 | 2;
  };

const bem = new BemHelper("title-protec");

export const TitleProtec: React.FC<Props> = ({ style, variant = 1, ...props }) => {
  return (
    <Typography.Title
      level={1}
      className={classNames(
        bem.block(),
        variant == 1 && bem.modifier("type-1"),
        variant == 2 && bem.modifier("type-2"),
      )}
      style={style}
      {...props}
    >
      {props.children}
    </Typography.Title>
  );
};
